import { defineStore } from 'pinia'

import { getTimezoneOffsetInHours } from 'www/utils'
import {
  FORM_CHECKBOXES_OF_CLASSES,
} from 'www/vue_components/common/AppointmentPage/constants'
// eslint-disable-next-line import/no-cycle
import useServiceDataStore from 'www/vue_components/common/AppointmentPage/stores/useServiceDataStore'
import useAppointmentDataStore from 'www/vue_components/common/AppointmentPage/stores/useAppointmentDataStore'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'

const useUserDataStore = defineStore('userDataStore', {
  state: () => ({
    isReadWarningInfo: false,
    isErrorWarningInfo: false,
    warningInfoTelemedEl: null,
    checkedCheckboxes: [],
    formCheckboxesRef: null,
    userPhone: '',
    userTimeDelta: getTimezoneOffsetInHours(),
  }),
  getters: {
    checkboxesData() {
      const serviceDataStore = useServiceDataStore()
      const data = FORM_CHECKBOXES_OF_CLASSES[serviceDataStore.serviceData.classTranslit] || []

      data.forEach(datum => {
        datum.label = datum.label.replace('\n', window.MOBILE_VERSION ? '<br>' : '')
      })

      return data
    },
    isCheckboxesChecked() {
      const appointmentDataStore = useAppointmentDataStore()

      return this.checkboxesData.length === this.checkedCheckboxes.length
        || !appointmentDataStore.appointmentRegistrationTypes.isDirect
    },
    isVisibleWarningInfoTelemed() {
      const appointmentDataStore = useAppointmentDataStore()
      const lpuDataStore = useLpuDataStore()

      return appointmentDataStore.isTelemedPaymentInfoVisible && !lpuDataStore.isTelemedMedical
    },
    isCheckedWarningInfoTelemed() {
      return this.isVisibleWarningInfoTelemed ? this.isReadWarningInfo : true
    },
  },
  actions: {
    updateCheckedCheckboxes(payload) {
      this.checkedCheckboxes = payload
    },
    updateFormCheckboxesRef(payload) {
      this.formCheckboxesRef = payload
    },
    updateIsReadWarningInfo(payload) {
      this.isReadWarningInfo = payload
    },
    updateIsErrorWarningInfo(payload) {
      this.isErrorWarningInfo = payload
    },
    updateWarningInfoTelemedEl(payload) {
      this.warningInfoTelemedEl = payload
    },

    validateCheckboxes() {
      if (!this.formCheckboxesRef) {
        return null
      }

      this.formCheckboxesRef.validate()

      return !this.isCheckboxesChecked
        ? this.formCheckboxesRef.$el
        : null
    },
    validateWarningInfoTelemed() {
      if (!this.isCheckedWarningInfoTelemed) {
        this.updateIsErrorWarningInfo(true)
        return this.warningInfoTelemedEl
      }

      return null
    },
  },
})

export default useUserDataStore
